<fui-rows [formGroup]="editService.formGroup">
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-currency-edit-control formControlName="price" [(ngModel)]="model.data.price"
                                               (valueChange)="baseDetailsChanged()"></wbo-currency-edit-control>
                    <wbo-currency-edit-control formControlName="baseCostEx" [(ngModel)]="model.data.baseCostEx"
                                               (valueChange)="baseDetailsChanged()"></wbo-currency-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-column>
            <wbo-edit-grid [data]="productPriceLevelData" [editable]="true" [entityPath]="'priceLevels'"
                           (saved)="saveHandler($event)">
                <wbo-edit-link-column field="priceLevel.name" componentPath="priceLevel"
                                      [editMode]="EditMode.VIEW"></wbo-edit-link-column>
                <wbo-price-level-markup-single-select-column field="markup.type" [editable]="true" [width]="180"
                                                             (valueChange)="markupTypeChanged($event)">
                </wbo-price-level-markup-single-select-column>
                <wbo-markup-value-column field="markup.value" markupField="markup" [editable]="true"
                                         [width]="150"></wbo-markup-value-column>
                <wbo-checkbox-column field="markup.roundingApplied" [editable]="true"
                                     [width]="100"></wbo-checkbox-column>
                <wbo-currency-column field="priceInc"></wbo-currency-column>
                <wbo-currency-column field="priceEx"></wbo-currency-column>
                <wbo-currency-column field="cost" [width]="250">
                    <ng-template headerTemplate>
                        <wbo-stock-costing-header
                            [(costingType)]="costingType" [(customCost)]="customCost" [(outletId)]="costingOutletId"
                            (detailsChange)="calculatePricing()" [allowCustomCost]="true"></wbo-stock-costing-header>
                    </ng-template>
                </wbo-currency-column>
                <wbo-currency-column field="profit"></wbo-currency-column>
                <wbo-percentage-column field="margin"></wbo-percentage-column>
            </wbo-edit-grid>
        </fui-column>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="excludeFromPromotions"
                                           [(ngModel)]="model.data.excludeFromPromotions"></wbo-checkbox-edit-control>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row>
        <fui-two-columns>
            <fui-column>
                <wbo-checkbox-edit-control formControlName="promptPrice"
                                           [(ngModel)]="model.data.promptPrice"
                                           (valueChange)="promptPriceChanged()"></wbo-checkbox-edit-control>
            </fui-column>
            <fui-column>
                <fui-tandem-field
                    *ngIf="model.data.promptPrice && (Config.PRODUCTLINE_PROMPT_FOR_PRICE_DEFAULT_OPTIONS | booleanConfig)">
                    <wbo-single-select-edit-control formControlName="promptForDefaultType"
                                                    [(ngModel)]="model.data.promptForDefaultType"
                                                    [allowClearSelectionOption]="false">
                        <wbo-select-options>
                            <wbo-select-option [value]="1" label="wbo.composite-product.edit.option.promptForPrice.none">
                            </wbo-select-option>
                            <wbo-select-option [value]="2" label="wbo.composite-product.edit.option.promptForPrice.fixed">
                            </wbo-select-option>
                            <wbo-select-option [value]="3" label="wbo.composite-product.edit.option.promptForPrice.roundUp">
                            </wbo-select-option>
                        </wbo-select-options>
                    </wbo-single-select-edit-control>
                    <wbo-currency-edit-control formControlName="promptForDefaultPrice"
                                               [(ngModel)]="model.data.promptForDefaultPrice"
                                               [overrideRequired]="true"
                                               *ngIf="model.data.promptPrice && (model.data.promptForDefaultType == 2 || model.data.promptForDefaultType == 3)"></wbo-currency-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
    <fui-row *ngIf="showScaleFields">
        <fui-two-columns>
            <fui-column>
                <fui-tandem-field>
                    <wbo-checkbox-edit-control formControlName="usesScales"
                                               [(ngModel)]="model.data.usesScales"></wbo-checkbox-edit-control>
                    <wbo-checkbox-edit-control formControlName="printScaleLabel"
                                               [(ngModel)]="model.data.printScaleLabel"></wbo-checkbox-edit-control>
                </fui-tandem-field>
            </fui-column>
        </fui-two-columns>
    </fui-row>
</fui-rows>
